import dayjs from 'dayjs'
import { useEffect } from 'react'
import utc from 'dayjs/plugin/utc'
import isToday from 'dayjs/plugin/isToday'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { useParamQuery } from 'hooks/useParamQuery'
import { getWebResultCndpSkin } from 'api/assessment'
import { showNotification } from '@mantine/notifications'

dayjs.extend(isToday)
dayjs.extend(utc)

export const useApp = () => {
	const { i18n } = useTranslation()
	const { params } = useParamQuery()
	const batchId = params.get('batch_id')
	const languageParam = params.get('language')
	const isthereBatchIdAndCustomerId = batchId !== null

	useEffect(() => {
		i18n.changeLanguage(languageParam ?? 'en')
	}, [])

	const { data = { secondsRemained: 120 * 60, isExpired: false }, isLoading } = useQuery(
		['web-result-cndpskin', batchId],
		async () => await getWebResultCndpSkin(String(batchId)),
		{
			select: data => {
				const analysisTime = dayjs.utc(data.data.body[0].time) // parse ISO UTC

				const now = dayjs.utc() // current UTC

				const secondsDifference = now.diff(analysisTime, 'second')

				const isExpired = secondsDifference > 120 * 60
				const secondsRemained = 120 * 60 - secondsDifference

				return { isExpired, secondsRemained }
			},

			onError: (err: any) => {
				showNotification({
					title: 'Error !!!',
					message: err.response.data.error,
				})
			},
			keepPreviousData: true,
			enabled: isthereBatchIdAndCustomerId,
		},
	)

	return { data, isLoading, isthereBatchIdAndCustomerId }
}
